export * from '../atleta/list/atletaList.component';
export * from '../atleta/create/atletaCreate.component';
export * from '../atleta/edit/atletaEdit.component';
export * from '../atleta/detail/atletaDetail.component';
export * from '../atleta/search/atletaSearch.component';